module.exports = {
  "title": "content map",
  "sub_text": "slice, dice, stash & cluster",
  "search_placeholder": "Type something ",
  "untitled": "Untitled",
  "selected_assets": "Selected {count} out of",
  "actions":{
    "all_contents": "All Content",
    "save_as": "Save as",
    "export": "Export",
    "exporting": "Exporting",
    "edit_content": "Edit Content",
    "delete_content": "Delete Content",
  },
  "filters":{
      "asset": "Asset",
      "asset_title": "Asset Title",
      "stream": "Stream",
      "file_type": "File Type",
      "tags": "Tags",
      "group": "Group",
      "expiry_date": "Expiry Date",
      "asset_status": "Asset Status",
      "no_options": "No options",
      "select_a_filter": "Select a filter",
      "sub_filter": {
        "is": "is",
        "is_not": "is Not",
        "contains": "contains",
        "is_empty": "is Empty",
        "is_not_empty": "is Not Empty",
        "expired": "expired",
        "no_expiration": "no expiration",
        "expiring": "expiring",
        "in_a_month": "In a month",
        "in_a_week": "In a week",
        "today": "Today",
      }
  },
  "sliders":{
    "delete":{
      "title": "deleting",
      "sub_text": "Are you sure you would like to delete the following assets?",
      "sorry": "Sorry",
      "however": "However",
      "no_permission": "you don't have permission to delete {count} of the selected assets."
    },
    "edit":{
      "title": "bulk edit",
      "sub_text": "Add/Edit all selected assets.",
      "expiration": "Expiration",
      "pick_a_date": "Pick a date",
      "tags": "Tags",
      "share_access": "Share access",
      "download_access": "Download access",
      "options":{
        "allow": "Allow",
        "restrict": "Restrict",
        "no_update": "No update",
      }
      
    },
    "cluster_delete":{
      "title": "deleting",
      "cluster": "cluster",
      "sub_text":"Are you sure you would like to delete the selected cluster?"
    }
  },
  "error_messages":{
    "data_source_delete": "Asset cannot be deleted since it is synced with datasource",
    "no_access": "Sorry, you don't have permission to delete 80 of the selected assets.",
    "empty_cluster_name":"Empty filter can't be save",
    "no_asset": "Looks like no assets present with applied filter",
    "empty_filter": "Empty filter can't be saved",
  },
  "toast":{
    "success": "{action} successfully",
    "export":{
      "title": "Would you like to export the",
      "asset_master_report": "Asset Master Report",
      "success": "Downloaded {name} Successfully",
      "failed": "Unable to process request, Please try after sometime"
    }
  }
}